import MuiListItemText, { ListItemTextProps } from '@mui/material/ListItemText';

export interface IListItemTextProps extends ListItemTextProps {}

const ListItemText = (props: IListItemTextProps): JSX.Element => {
  return <MuiListItemText {...props} />;
};

export default ListItemText;
